var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSportLogo = function SvgSportLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.918 10.336-4.9.018.053 14.568-4.122-1.23-.048-13.323L0 10.387.114 41.37l4.91 2.333-.054-14.462 4.122 1.232.055 15.19 2.52 1.2L14.056 48l-.009-2.291-.13-35.373ZM31.918 27.778l-4.892 1.463.037 9.448-3.915 1.897-.091-25.245 3.92-.015.033 8.377 4.892-1.463-.046-11.879-13.723-.025.137 37.556 13.698-6.637.01-.005-.06-13.472ZM32.002 0H.023v7.252h31.979V0Z",
    fill: "#fff"
  })));
};
export default SvgSportLogo;